module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-20-2a94e24e4e96beda57f117ec8035db88.jpg";